module.exports = __webpack_public_path__ + "img/Very-Basic-Design-icon-y.ccdd5f48.png";